/* eslint-disable */


/**
 * Create styles for `<OrderDetailsSideNav />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<OrderDetailsSideNav />` styles
 */
const orderDetailsSideNavStyles = ({ theme }) => ({});

export default orderDetailsSideNavStyles;
